import {
	LRLanguage, LanguageSupport, indentNodeProp, foldNodeProp, foldInside, delimitedIndent,
} from '@codemirror/language';
import { styleTags, tags as t } from '@lezer/highlight';
import { buildParser } from '@lezer/generator';
import { makeGrammar } from './syntax.grammar';

const builderParser = infos => {
	const grammar = makeGrammar(Object.keys(infos.functions));
	return buildParser(grammar);
};

export const parser = infos => builderParser(infos).configure({
	props: [
		indentNodeProp.add({
			Function: delimitedIndent({ closing: ')', align: true }),
		}),
		foldNodeProp.add({
			Function: foldInside,
		}),
		styleTags({
			Boolean: t.bool,
			String: t.string,
			Number: t.number,

			FnKeyword: t.function(t.variableName),
			Operator: t.operator,
			LineComment: t.lineComment,
			'( )': t.paren,
		}),
	],
});

export const KAlgoLanguage = infos => LRLanguage.define({
	parser: parser(infos),
	languageData: {
		commentTokens: { line: '//' },
	},
});

/**
	* @param infos
	*/
export function KAlgo(infos) {
	return new LanguageSupport(KAlgoLanguage(infos));
}
